import { render, staticRenderFns } from "./VaultSelectorItem.vue?vue&type=template&id=4ad1aeb4&"
import script from "./VaultSelectorItem.vue?vue&type=script&lang=ts&"
export * from "./VaultSelectorItem.vue?vue&type=script&lang=ts&"
import style0 from "./VaultSelectorItem.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports